<template>
  <div class="p-3 px-4 text-left header-bar">
    <h2>
      {{ title || clientConfig.content.general.modellerName }}
    </h2>
  </div>
</template>

<script>
import clientConfig from '/src/config/client';

export default {
  name: 'HeaderFragment',
  
  props: {
    title: String
  },

  data() {
    return {
      clientConfig
    }
  }
}
</script>
